import { CreatePreRegNotifyEmailRequestModel, CreatePreRegNotifyEmailResponseModel, UpdatePreRegNotifyEmailRequestModel, UpdatePreRegNotifyEmailResponseModel } from "models/backend/PreRegistrationModel";
import { getApiKeyForHotel, getToken, privateHttpClient } from "utils/httpClient";

export const updatePreRegistrationNotifyEmailAPI = async (
  request: UpdatePreRegNotifyEmailRequestModel
): Promise<UpdatePreRegNotifyEmailResponseModel> => {
  const { data } = await privateHttpClient.put(
    '/api/PreRegistration/NotifyEmail',
    { ...request},
    {
      headers: {
        'Content-type': 'application/json',
        Authorization: `Bearer ${getToken()}`,
        ApiKey: getApiKeyForHotel()
      }
    }
  );
  return data;
};

export const createPreRegistrationNotifyEmailAPI = async (
    request: CreatePreRegNotifyEmailRequestModel
  ): Promise<CreatePreRegNotifyEmailResponseModel> => {
    const { data } = await privateHttpClient.post(
      '/api/PreRegistration/NotifyEmail',
      { ...request},
      {
        headers: {
          'Content-type': 'application/json',
          Authorization: `Bearer ${getToken()}`,
          ApiKey: getApiKeyForHotel()
        }
      }
    );
    return data;
  };